<template>
  <div class="multiselect-users">
    <multiselect
      ref="multiselect"
      v-model="selected_user"
      :options="options_users"
      :searchable="true"
      :multiple="true"
      :hide-selected="true"
      :close-on-select="false"
      :clear-on-select="false"
      :max="maxSignup"
      :placeholder="$t('reviews.intervals.add-participant')"
      :allow-empty="true"
      :loading="usersLoading"
      track-by="lmsUserId"
      label="fullName"
      :disabled="fullList || subcribeFinish(review)"
      @input="signupSelectedUser"
    >
      <template slot="tag" slot-scope="{ option, remove }">
        <div class="content-tag">
          <div class="option_tag">
            <p>{{ option.fullName }}</p>
            <button size="sm" variant="light" @click="remove(option)">
              <b-icon-x-circle
                scale="1"
                @click="remove(option)"
              ></b-icon-x-circle>
            </button>
          </div>
        </div>
      </template>
      <!-- <template slot="option" slot-scope="props">
        <div class="ms-2">
          <b-form-checkbox
            :name="props.option.lmsUserId"
            :checked="isSelected(props.option)"
            @change="doNothing"
          >
            <span>{{ props.option.fullName }}</span>
          </b-form-checkbox>
        </div>
      </template> -->
      <template slot="maxElements"
        >{{ $t("reviews.intervals.limit-msg", { limit: limitParticipants }) }}
      </template>
      <template slot="noResult">
        {{ $t("reviews.intervals.not-found") }}
      </template>
    </multiselect>
  </div>
</template>
<script>
import utilitiesMixin from "@/mixins/utilitiesMixin";
import Multiselect from "vue-multiselect";
import {BIconX, BIconXCircle} from "bootstrap-vue";
import users from "@/service/users";

export default {
  name: "MultiselectUser",
  mixins: [utilitiesMixin],
  components: { Multiselect, BIconX,BIconXCircle },
  props: [
    "review",
    "item",
    "fullList",
    "options_users",
    "limitParticipants",
    "numOfSignups",
    "usersLoading",
  ],
  mounted() {
    this.maxSignup =
      parseInt(this.limitParticipants) - parseInt(this.numOfSignups);
  },
  data() {
    return {
      selected_user: [],
      maxSignup: 0,
    };
  },
  methods: {
    signupSelectedUser() {
      this.$emit("addSelect", this.item, this.selected_user);
    },
  },
};
</script>
